import type { MeshSnapshot } from "../domain/mesh";

/** Keep authored cartography, never promote demonstration telemetry to live data. */
export function withoutOperationalData(snapshot: MeshSnapshot): MeshSnapshot {
  return {
    ...snapshot,
    nodes: snapshot.nodes.map((node) => ({
      ...node,
      status: "warning",
      metrics: { meta: "UNVERIFIED · NO SERVICE TELEMETRY" },
    })),
    orbitals: snapshot.orbitals.map((orbital) => ({
      ...orbital,
      status: "warning",
      metrics: { meta: "UNVERIFIED · NO COMPONENT TELEMETRY" },
    })),
    events: [],
  };
}
